export default {
      id: "close-usage",
      viewBox: "0 0 21.291 21.291",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#close",
      toString: function () {
        return this.url;
      }
    }